export { default } from "./[cameraKey].web";
